module.exports = __webpack_public_path__ + "static/media/DanielRualesResume.68131a95.pdf";